import './App.css';
import CompassiaLanding from "./pages/CompassiaLanding/CompassiaLanding";
import AvisoLegal from "./pages/AvisoLegal/AvisoLegal";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PoliticaPrivacidad from "./pages/PoliticaPrivacidad/PoliticaPrivacidad";
import Cookies from "./pages/Cookies/Cookies";

function App() {
  return (
      <Router>
          <div className="App" style={{ height: "100vh", width: "100vw" }}>
              <Routes>
                  <Route path="/" element={<CompassiaLanding />} />
                  <Route path="/aviso-legal" element={<AvisoLegal />} />
                  <Route path="/politica-privacidad" element={<PoliticaPrivacidad />} />
                  <Route path="/cookies" element={<Cookies />} />
              </Routes>
          </div>
      </Router>
  );
}

export default App;
